module.exports = __webpack_public_path__ + "static/media/flashlight.e9f88e8d.svg";